import { Select,Form,Input,Switch, DatePicker } from 'antd';
import Modal from 'react-bootstrap/Modal';
import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { LeftCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {app} from '../../config';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import axios from 'axios';

const AddPayment = () => {
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];

  const navigate = useNavigate()
  const token= getTokenfromUserObj()


  const [addUserResp, setAddUserResp] = useState({});
  const [uploadObj, setUploadObj] = useState({});
  const [show, setShow] = useState(false);

  const { t } = useTranslation(['common']);

  let user = JSON.parse(localStorage.getItem('user'));

  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
    
      organizationId:  user.userType==="A" && values.organizationId ? values.organizationId : user.organizationId,
      expiry_date: values.expiryDate ? values.expiryDate.format().split('T')[0] : null,
      paymentUrl:values.paymenturl ? values.paymenturl : "",
      isActive: values.isActive===true ? 1 :0,
      
    });
    setShow(true);
  };

  const uploadData=async(uploadObj)=>{
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/paymentlink/add`, uploadObj,{headers:{auth:token}});
      if (res.data.statusCode===200){
        setAddUserResp(res.data)
        setTimeout(()=>{
          if(user.userType==="A")navigate('/paymentlink/view', { replace: true });
          else if(user.userType==="O")navigate('/paymentlink/view', { replace: true });
        },1000)
      } 
    } catch (err) {
      console.log(err);
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const submitData=()=>{
    console.log('calling')  
    if (Object.keys(uploadObj).length > 0) {
     
          uploadData(uploadObj);
  }
  setShow(false)
}

  const handleClose = () => setShow(false);
  return (
    <div class='container'>
      <div class='row mt-4 w-75 tbl'>
        <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            <LeftCircleOutlined
              onClick={() => {
                if (user.userType === 'A') navigate('/paymentlink/view', { replace: true });
                else if (user.userType === 'O') navigate('/paymentlink/view', { replace: true });
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add Payment')} </h2>
          </div>{' '}
        </div>

        <div class='col-lg-11 mb-5 mt-3 '>
          <div class='col-lg-9 align-self-center mt-2 mb-4'>
            <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['id']: 1,
                ['causename']: 'Hammad',
                ['isActive']: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              {user.userType === 'A' ? (
                <Form.Item
                  label='Organization'
                  name='organizationId'
                  rules={[
                    {
                      required: true,
                      message: 'Select organization',
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    placeholder='Select Organization'
                    style={{
                      width: 260,
                    }}
                  >
                    {orgs.map((orgs) => {
                      return (
                        <Option key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              ) : (
                ' '
              )}

              <Form.Item
                colon={false}
                label='Payment Url'
                name='paymenturl'
                rules={[
                  {
                    required: true,
                    message: 'Enter payment url',
                  },
                ]}
              >
                <Input placeholder='Enter Payment url' />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Expiry Date'
                name='expiryDate'
                rules={[
                  {
                    required: true,
                    message: 'select Expiry date',
                  },
                ]}
              >
                <DatePicker
                  placeholder='Select Expiry Date'
                  // disabledDate={(current) => {
                  //   let customDate = moment().format("MM-DD-YYYY");
                  //   return current && current < moment(customDate, "MM-DD-YYYY");
                  // }}
                />
              </Form.Item>
              

             
              
              

              

             
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>

              <Form.Item
                colon={false}
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                {addUserResp.statusCode === 200 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : addUserResp.statusCode === 400 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Failed</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.data.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to add Payment Link?</Modal.Body>
                    <Modal.Footer>
                      <Button variant='secondary' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' htmlType='submit' onClick={submitData} >
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Save
                </button>
                {/* <Button type="primary" htmlType="submit">
  Submit
</Button> */}
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddPayment